import "./customTooltip.scss";

const CustomTooltip = ({ data }) => {
  return (
    data?.message && (
      <div
        className="custom-tooltip"
        style={{
          bottom: window.innerHeight - data.positionY + 5,
          left: data.positionX - 5,
        }}
      >
        <div className="no-margin-last">
          {data.message.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </div>
    )
  );
};

export default CustomTooltip;
